import { useContext } from "react";
import { AdminContext } from "../context/AdminContext";
//dumb component 
const PaginationControls = ({totalPages,currentPage,totalUsers,setUserPerPage,userPerPage}) =>{
    // const {totalPages,currentPage,totalUsers,setUserPerPage,userPerPage} = useContext(AdminContext)    
    const startPage = (currentPage - 1) * userPerPage;
    const handleUserPerPage = (e) =>{
        setUserPerPage(e.target.value);
    }
    return (
        <>
        <div className="flex justify-between mb-2">
            {/* left side  */}
            <div className="flex flex-col justify-center items-center space-y-3">
                <p className="text-sm text-gray-800">showing {startPage + 1} - {Math.min(currentPage * userPerPage,totalUsers)} of {totalUsers} records</p>
                <h1 className="text-2xl text-gray-700 font-medium">User Records</h1>
            </div>
            {/* right side  */}
            <div className="flex flex-col justify-center items-center space-y-3">
                <p className="text-sm text-gray-800">Page {currentPage} of {totalPages}</p>
                <div className="flex space-x-2">
                <p className="text-gray-800">Rows Perpage:</p>
                <select onChange={handleUserPerPage} name="page" id="page">
                    <option value="10">10</option>
                    <option value={totalUsers}>All</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                </select>
                </div>
            </div>
        </div>
        </>
    )
}

export default PaginationControls;